// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"0f137623","437":"e5092672","627":"e5092672"}[chunkId] + ".chunk.css";
};